import { parseISO } from 'date-fns';

export const sortWorkspaceByLastUsedDesc = <I extends { lastUsed: string }>(workspaces: I[]): I[] =>
  [...workspaces].sort((a, b) => parseISO(b.lastUsed).getTime() - parseISO(a.lastUsed).getTime());
